"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var createItemContextsForDeleteStoreUpdate_1 = require("./helpers/createItemContextsForDeleteStoreUpdate");
var deleteItemsStoreUpdate_1 = require("owa-mail-actions/lib/triage/deleteItemsStoreUpdate");
var getInstrumentationContextsFromTableView_1 = require("owa-mail-list-store/lib/utils/getInstrumentationContextsFromTableView");
var markItemsJunkNotJunkBasedOnItemIds_1 = require("./helpers/markItemsJunkNotJunkBasedOnItemIds");
var owa_mail_list_store_1 = require("owa-mail-list-store");
/**
 * The action which marks items as junk.
 * @param itemRowKeys - the rows to mark as junk
 * @param tableView - the table view the items are from
 * @param isJunkValueToSet - whether it is a mark as junk or not junk action
 * @param actionSource - where the action is triggered from
 */
function markItemsJunkNotJunkFromTable(itemRowKeys, tableView, isJunkValueToSet, actionSource) {
    var itemIdStrings = owa_mail_list_store_1.getRowIdsFromRowKeys(itemRowKeys, tableView.id);
    var instrumentationContexts = getInstrumentationContextsFromTableView_1.default(itemRowKeys, tableView);
    markItemsJunkNotJunkBasedOnItemIds_1.default(itemIdStrings, isJunkValueToSet, actionSource, instrumentationContexts, function () {
        var itemContexts = createItemContextsForDeleteStoreUpdate_1.default(itemIdStrings);
        // Dispatch action to update the store state
        deleteItemsStoreUpdate_1.default(itemContexts, tableView.tableQuery.folderId);
    });
}
exports.default = markItemsJunkNotJunkFromTable;
//# sourceMappingURL=markItemsJunkNotJunkFromTable.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/mail/orchestration/owa-mail-triage-action/lib/actions/markItemsJunkNotJunkFromTable.js
// module id = 5655
// module chunks = 62